import { extractFiscalYearNumber, fiscalYearsMatch } from "./fiscalYearMatch";

function parseYmdToUtc(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return null;
  const d = new Date(`${ymd}T00:00:00.000Z`);
  return Number.isNaN(d.getTime()) ? null : d;
}

function ymdFromUtc(date) {
  return date.toISOString().slice(0, 10);
}

function addUtcYears(date, years) {
  const d = new Date(date.getTime());
  d.setUTCFullYear(d.getUTCFullYear() + years);
  return d;
}

function addUtcDays(date, days) {
  const d = new Date(date.getTime());
  d.setUTCDate(d.getUTCDate() + days);
  return d;
}

/**
 * FY window for a fiscal year label, anchored to Current FY start date from settings.
 * Current FY may cap fyEndYmd at asOfYmd (YTD).
 */
export function buildFyWindowYmdForYear(fiscalYear, currentFy, currentFyStartYmd, { asOfYmd } = {}) {
  const targetEndYear = extractFiscalYearNumber(fiscalYear);
  const currentEndYear = extractFiscalYearNumber(currentFy);
  if (!targetEndYear || !currentFyStartYmd) return null;

  const templateStart = parseYmdToUtc(String(currentFyStartYmd).trim());
  if (!templateStart) return null;

  const yearOffset = currentEndYear != null ? targetEndYear - currentEndYear : 0;
  const fyStart = addUtcYears(templateStart, yearOffset);
  let fyEnd = addUtcDays(addUtcYears(fyStart, 1), -1);

  if (asOfYmd) {
    const asOf = parseYmdToUtc(asOfYmd);
    if (asOf && asOf < fyEnd) {
      fyEnd = asOf;
    }
  }

  return {
    fyStartYmd: ymdFromUtc(fyStart),
    fyEndYmd: ymdFromUtc(fyEnd),
  };
}

export function sopFyUsesYtdAsOf(fiscalYear, currentFy) {
  return fiscalYearsMatch(fiscalYear, currentFy);
}
